import type { ReactNode } from 'react'
import { fbt } from 'fbtee'
import { Section } from '../../components/Section'
import { EventCard } from '../../components/EventCard'
import { placeholders } from '../../lib/skeletonUtils'
import type { Event } from '../../types'
import { FOR_YOU_COUNT } from './useForYou'

export function ForYouSection({
  events,
  personalized,
  loading,
  action,
  renderCard,
}: {
  events: Event[]
  personalized: boolean
  loading: boolean
  action?: ReactNode
  renderCard: (event: Event) => ReactNode
}) {
  return (
    <Section
      testId="for-you"
      action={action}
      title={
        personalized
          ? fbt('For you', 'Home section heading for nearby events ranked by the artists the user follows and overall popularity')
          : fbt('Popular near you', 'Home section heading for the most popular upcoming events in the user’s area')
      }
    >
      {loading
        ? placeholders(Math.min(3, FOR_YOU_COUNT)).map((_, i) => <EventCard key={i} loading />)
        : events.map(renderCard)}
    </Section>
  )
}
